import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius4};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.secondary};
`
